import pluralize from '@/utils/pluralize';

const labelFormatter = (count, options) =>
  `${count} ${pluralize(count, options)}`;

export default labelFormatter;
